import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import type { useIsCardPullFrozen_currentUser } from './__generated__/useIsCardPullFrozen.graphql.ts';

export const useIsCardPullFrozen = (
  currentUser: Nullable<useIsCardPullFrozen_currentUser>
) => {
  const {
    flags: {
      craftingInterfaceEnabledSports = ['football'],
      craftingEnabledSports = ['football'],
    },
  } = useFeatureFlags();
  const { sport } = useSportContext();
  const lowercaseSport = sport.toLowerCase();

  const cardPull = currentUser?.cardPull;

  return (
    // backend is disabled
    !craftingEnabledSports.includes(lowercaseSport) ||
    // frontend is disabled and user doesn't have a card pull in progress
    (!cardPull && !craftingInterfaceEnabledSports.includes(lowercaseSport))
  );
};

useIsCardPullFrozen.fragments = {
  currentUser: gql`
    fragment useIsCardPullFrozen_currentUser on CurrentUser {
      slug
      cardPull(sport: $sport) {
        id
      }
    }
  ` as TypedDocumentNode<useIsCardPullFrozen_currentUser>,
};
